import { getMajorVersion, getKitSciVersion } from '@repo/utils';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useFeature from './useFeature';

export const GUT_RESILIENCE_SCORE_FEATURE_FLAG = 'gut_resilience_score';
export const GUT_RESILIENCE_SCORE_MIN_MAJOR_VERSION = 4;

const useIsGutResilienceScoreEnabled = () => {
  const { isFeatureEnabled, isLoading } = useFeature(
    GUT_RESILIENCE_SCORE_FEATURE_FLAG,
  );
  const { currentKit } = useCurrentKitAndTinyAccount();
  const kitMajorVersion = getMajorVersion(getKitSciVersion(currentKit));

  const isEnabled =
    isFeatureEnabled &&
    !!kitMajorVersion &&
    kitMajorVersion >= GUT_RESILIENCE_SCORE_MIN_MAJOR_VERSION;

  return { isEnabled, isLoading };
};

export default useIsGutResilienceScoreEnabled;
